<div class="root">
    <section class="header">
        <nlr-header [menuItem]="title"></nlr-header>
    </section>

    <section
        id="inner"
        class="content">
        <nlr-inner></nlr-inner>
    </section>

    <section class="footer">
        <nlr-footer></nlr-footer>
    </section>
</div>
